/* eslint-disable */
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Form,
  Button,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  CardText,
  CardFooter,
} from "reactstrap";

import Step1 from "./Step1";
import Step2 from "./Step2";
import Step3 from "./Step3";
import Step4 from "./Step4";
import Step5 from "./Step5";
import CurrentInfo from "./CurrentInfo";
import MultiStepProgressBar from "./MultiStepProgressBar";

import useToast from "../../hooks/useToast";
import useInput from "../../hooks/useInput";

import pageService from "../../service/page.service";
import scriptService from "../../service/script.service";
import linkService from "../../service/link.service";
import styleService from "../../service/style.service";
import coverService from "../../service/cover.service";
import avatarService from "../../service/avatar.service";

import styles from "./Form.module.css";

const NewPageForm = () => {
  const getErrorMessage = (error) =>
    (error.response && error.response.data && error.response.data.message) ||
    error.message ||
    error.toString();

  const initialPageState = {
    title: "",
    description: "",
  };

  const initialLinkStyleState = {
    bgColor: "#EC2222",
    fontColor: "#ffffff",
    borderStyle: "40px",
    hoverBgColor: "#ffffff",
    hoverFontColor: "#EC2222",
  };

  const initialLinksState = {
    linkName: "",
    linkUrl: "",
  };

  const initialScriptState = {
    title: "",
    code: "",
    position: "head",
  };

  const [currentStep, setCurrentStep] = useState(1);
  const [currentPageId, setCurrentPageId] = useState(0);
  const [avatar, setAvatar] = useState(null);
  const [cover, setCover] = useState(null);
  const [page, setPage] = useState(initialPageState);
  const [linkStyle, setLinkStyle] = useState(initialLinkStyleState);
  const [links, setLinks] = useState(initialLinksState);
  const [postedLinks, setPostedLinks] = useState([]);
  const [scripts, setScripts] = useState(initialScriptState);
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const [pageData, setPageData] = useState({});
  const [updateState, setUpdateState] = useState(false);

  const {
    putToast,
    putCoverToast,
    putAvatarToast,
    putStyleToast,
    postLinkToast,
    deleteLinkToast,
    postScriptToast,
    deleteScriptToast,
  } = useToast();

  const {
    handlePageChange,
    handleCoverChange,
    handleAvatarChange,
    handleLinkStyleChange,
    handleLinkChange,
    handleScriptChange,
  } = useInput({
    setPage,
    page,
    setCover,
    cover,
    setAvatar,
    avatar,
    setLinkStyle,
    linkStyle,
    setLinks,
    links,
    setScripts,
    scripts,
  });

  const navigate = useNavigate();
  let id = useParams();

  useEffect(() => {
    pageService.getPage(id).then((res) => setPageData(res.data));
  }, [updateState]);

  const handleSubmit = (event) => {
    event.preventDefault();
  };

  const updateInfo = async () => {
    try {
      const admin = JSON.parse(localStorage.getItem("admin"));
      const newPage = {
        title: page.title,
        description: page.description,
      };
      let idId = id.id;

      await pageService.updatePage({ idId, newPage, admin });
      putToast();

      const data = await pageService.getPage(id);
      setPageData(data.data);
    } catch (error) {
      setMessage(getErrorMessage(error));
    }
  };

  const updateCover = async () => {
    const admin = JSON.parse(localStorage.getItem("admin"));
    let idId = id.id;

    setMessage("");
    if (!cover) {
      return setMessage("Selecione uma capa!");
    }
    setMessage("");

    const coverData = new FormData();
    coverData.append("file", cover, cover.name);

    try {
      await coverService.putCover({ coverData, admin, idId });
      setCover(null);
      putCoverToast();

      const data = await pageService.getPage(id);
      setPageData(data.data);
    } catch (error) {
      setMessage(getErrorMessage(error));
    }
  };

  const updateAvatar = async () => {
    const admin = JSON.parse(localStorage.getItem("admin"));
    let idId = id.id;

    setMessage("");
    if (!avatar) {
      return setMessage("Selecione um avatar!");
    }
    setMessage("");

    const avatarData = new FormData();
    avatarData.append("file", avatar, avatar.name);

    try {
      await avatarService.putAvatar({ avatarData, admin, idId });
      setAvatar(null);
      putAvatarToast();

      const data = await pageService.getPage(id);
      setPageData(data.data);
    } catch (error) {
      setMessage(getErrorMessage(error));
    }
  };

  const updateStyle = async () => {
    const admin = JSON.parse(localStorage.getItem("admin"));
    let idId = id.id;

    const styleData = {
      bgColor: linkStyle.bgColor,
      fontColor: linkStyle.fontColor,
      borderStyle: linkStyle.borderStyle,
      hoverBgColor: linkStyle.hoverBgColor,
      hoverFontColor: linkStyle.hoverFontColor,
    };

    await styleService
      .updateStyle({ admin, idId, styleData })
      .then(putStyleToast)
      .catch((err) => console.log(err));

    const data = await pageService.getPage(id);
    setPageData(data.data);
  };

  const _next = async () => {
    let currStep = currentStep;

    if (!message && message === "") {
      currStep = currentStep >= 4 ? 5 : currentStep + 1;
    }
    setCurrentStep(currStep);
  };

  const handleNewLink = async () => {
    const admin = JSON.parse(localStorage.getItem("admin"));
    let currentPageId = id.id;

    if (!links.linkName) {
      return setMessage("Insira um nome");
    }
    setMessage("");
    if (!links.linkUrl) {
      return setMessage("Insira a URL");
    }
    const link = {
      title: links.linkName,
      url: links.linkUrl,
    };

    await linkService.postLink({ currentPageId, admin, link });
    postLinkToast();

    const data = await pageService.getPage(id);
    setPageData(data.data);
  };

  const handleDeleteLink = async (e) => {
    const admin = JSON.parse(localStorage.getItem("admin"));
    let currentPageId = id.id;
    let linkId = e.target.id;

    await linkService.deleteLink({ admin, currentPageId, linkId });
    deleteLinkToast();

    const data = await pageService.getPage(id);
    setPageData(data.data);
  };

  const handleNewScript = async () => {
    const admin = JSON.parse(localStorage.getItem("admin"));
    let idId = id.id;

    if (!scripts.title) {
      return setMessage("Insira o nome do Script");
    }
    setMessage("");
    if (!scripts.code) {
      return setMessage("Insira o código do Script");
    }
    const script = {
      title: scripts.title,
      code: scripts.code,
      position: scripts.position,
    };

    await scriptService
      .postScript({ admin, script, idId })
      .then(setScripts({ ...scripts, title: "", code: "" }));
    postScriptToast();

    const data = await pageService.getPage(id);
    setPageData(data.data);
  };

  const handleDeleteScript = async (e) => {
    const admin = JSON.parse(localStorage.getItem("admin"));
    let idId = id.id;
    let scriptId = e.target.id;

    await scriptService.deleteScript({ admin, idId, scriptId });
    deleteScriptToast();

    const data = await pageService.getPage(id);
    setPageData(data.data);
  };

  const _prev = () => {
    const currStep = currentStep <= 1 ? 1 : currentStep - 1;;
    setCurrentStep(currStep);
  };

  const end = () => {
    navigate(-1);
  };

  return (
    <>
      <Form onSubmit={handleSubmit}>
        <Card>
          <CardHeader className="centerr">
            <h3>
              Editando página: <b className="ml-2">{pageData.title}</b>
            </h3>
          </CardHeader>
          <CardBody>
            <CardTitle>
              <MultiStepProgressBar currentStep={currentStep} />
            </CardTitle>
            <CardText />
            <CardHeader className="mt-5">
              <CurrentInfo
                deleteLink={handleDeleteLink}
                currentStep={currentStep}
                style={styles}
                pageData={pageData}
                deleteScript={handleDeleteScript}
                isEditing={true}
              />
            </CardHeader>
            <br />
            <Step1
              update={updateInfo}
              isEditing={true}
              stepTitle="Editar informações"
              pageData={pageData}
              currentStep={currentStep}
              handlePageChange={handlePageChange}
              title={page.title}
              description={page.description}
            />
            {error && error}
            <Step2
              updateAvatar={updateAvatar}
              stepTitle="Editar Imagens"
              updateCover={updateCover}
              isEditing={true}
              currentStep={currentStep}
              handleCoverChange={handleCoverChange}
              handleAvatarChange={handleAvatarChange}
              cover={cover}
              avatar={avatar}
              isCreating={false}
            />
            <Step3
              update={updateStyle}
              stepTitle="Editar estilo de exibição dos links"
              pageData={pageData}
              setLinkStyle={setLinkStyle}
              isEditing={true}
              currentStep={currentStep}
              bgColor={linkStyle.bgColor}
              fontColor={linkStyle.fontColor}
              borderStyle={linkStyle.borderStyle}
              hoverBgColor={linkStyle.hoverBgColor}
              hoverFontColor={linkStyle.hoverFontColor}
              handleLinkStyleChange={handleLinkStyleChange}
              postedLinks={postedLinks}
            />
            <Step4
              currentStep={currentStep}
              handleLinkChange={handleLinkChange}
              linkName={links.linkName}
              linkUrl={links.linkUrl}
              handleNewLink={handleNewLink}
              id={currentPageId}
            />
            <Step5
              currentStep={currentStep}
              handleScriptChange={handleScriptChange}
              scriptName={scripts.title}
              scriptCode={scripts.code}
              scriptLocation={scripts.position}
              handleNewScript={handleNewScript}
            />
          </CardBody>
          <CardFooter>
            {message && (
              <div className="form-group">
                <div className="alert alert-danger" role="alert">
                  {message}
                </div>
              </div>
            )}
            {currentStep > 1 && (
              <Button
                className={styles.button_form}
                color="primary float-left"
                onClick={_prev}
              >
                Voltar
              </Button>
            )}
            {currentStep < 5 && (
              <Button
                className={styles.button_form}
                color="primary float-right"
                onClick={_next}
              >
                Próximo
              </Button>
            )}
            {currentStep > 4 && (
              <Button
                onClick={end}
                className={styles.button_form}
                color=" float-right"
              >
                Finalizar
              </Button>
            )}
          </CardFooter>
        </Card>
      </Form>
    </>
  );
};

export default NewPageForm;
